import { UploadData } from '../../../../store/uploadStore';
import { UploadNotRestoredError } from '../../../../errors/UploadNotRestoredError';
import { mapUploadTypeToMetricsEntityType } from '../../../../libs/metrics/metricUtils';
import { Point } from '@influxdata/influxdb-client-browser';
import { influxWriter } from '../../../../libs/metrics/InfluxWriter';

export const sendUploadCompletedPercent = (upload: UploadData) => {
  if (!upload.upload) throw new UploadNotRestoredError();

  const total = upload.meta.uploadSize;
  const uploaded = upload.meta.uploadedSize ?? 0;

  if (total) {
    // This used to calculate percentage using file count, but it isn't representative for LiDARs
    // As a side effect, the percentage doesn't consider file registration requests now (they are SLOW),
    // so we can have multiple identical points if parallel uploads line up
    const percent = ((uploaded / total) * 100).toFixed(2);

    const point = new Point();
    point.tag('Customer', upload.upload.customer);
    point.tag('Site', upload.upload.site);
    point.tag('EntityType', mapUploadTypeToMetricsEntityType(upload.meta.type));

    point.floatField('value', +percent);

    influxWriter.send('UploadCompletedPercent', point);
  }
};
